goog.provide("shadow.js.shim.module$src$svg$person$person_2_outlined_svg$default");
shadow.js.shim.module$src$svg$person$person_2_outlined_svg$default = shadow.js.shim.module$src$svg$person$person_2_outlined_svg.default;
